import methods from '@/services/methods'

export default {
  list (payload) {
    return methods.sendGet(`upi_collections/list`, payload, {unprivilege: 'UPI Collections', noHyptoLoader: true})
  },
  create (payload) {
    return methods.sendPost(`upi_collections`, payload, {restrictToast: true})
  },
  search (payload) {
    return methods.sendGet(`upi_collections/search_v2`, payload, {noHyptoLoader: true, unprivilege: 'UPI Collections'})
  },
  fetchStatus (id) {
    return methods.sendGet(`upi_collections/${id}/status`)
  },
  createRefund (id) {
    return methods.sendPost(`upi_collections/${id}/refund`)
  },
  refunds (id) {
    return methods.sendGet(`upi_collections/${id}/fetch_refunds`)
  },
  resendWebhook (id) {
    return methods.sendPost(`upi_collections/${id}/resend_webhook`)
  },
  bulkResendWebhook (payload) {
    return methods.sendPost(`upi_collections/bulk_resend_webhook`, payload)
  },
  export (payload) {
    return methods.sendGet(`upi_collections/export`, payload)
  }
}
